import React, { PropTypes, Component } from 'react'
import styles from './styles'
import ReviewRow from './reviewRow'
import misc from 'utils/misc'

export default class ReviewTable extends Component {
  static propTypes = {
    me: PropTypes.object,
    users: PropTypes.array,
    projects: PropTypes.array,
    weekReport: PropTypes.object,
    onWeekReportChange: PropTypes.func,
    onPrintClick: PropTypes.func,
    withControl: PropTypes.bool,
  };

  constructor (props, context) {
    super(props, context)
    this.print = ::this.print
    this.confirm = ::this.confirm
    this.revert = ::this.revert
  }

  print () {
    window.print()
    setTimeout(() => window.close(), 1)
  }

  confirm () {
    this.props.onWeekReportChange('confirm')
  }
  revert () {
    this.props.onWeekReportChange('revert')
  }

  render () {
    const { me, users, projects, weekReport, onWeekReportChange, withControl } = this.props

    if (weekReport.reviews.length === 0) {
      return (
        <div style={{ border: 'none' }} className={styles.reviewTable}>
          <div className={styles.reviewTitle}>
            加班審查：
            <span className={styles.acceptText}>已通過(無加班)</span>
            {withControl ?
            <div className={styles.submit}>
              <input type="submit" value="列印" onClick={this.print} />
            </div> : null}
            {
              (weekReport && !weekReport.isDone && (me.role === 'admin' || me.role === 'manager')) ?
              <div className={styles.confirm}>
                <input type="submit" value="會計部確認" onClick={this.confirm} />
              </div> :
              <div className={styles.submit}>
                <span>工時已確認</span>
              </div>
            }
            {
              (weekReport && weekReport.isDone && me.role === 'admin') ?
              <div className={styles.submit}>
                <input type="submit" value="取消確認" onClick={this.revert} />
              </div> : null
            }
          </div>
        </div>
      )
    }

    const projectNames = misc.getDict(projects, 'name')
    const userNames = misc.getDict(users, 'name')

    let reviewState = <span className={styles.inReview}>審查中</span>
    let isAllAccept = true
    let isAnyReject = false
    weekReport.reviews.forEach(review => {
      if (review.state !== 'accept') {
        isAllAccept = false
      }
      if (review.state === 'reject') {
        isAnyReject = true
      } })

    if (isAnyReject) {
      reviewState = <span className={styles.rejectText}>已退回</span>
    } else if (isAllAccept) {
      reviewState = (
        <div style={{ display: 'inline-block' }}>
          <span className={styles.acceptText}>已通過</span>
          {withControl ? <div className={styles.submit}>
            <input type="submit" value="列印" onClick={this.print} />
          </div> : null}
          {
            (weekReport && !weekReport.isDone && (me.role === 'admin' || me.role === 'manager')) ?
            <div className={styles.confirm}>
              <input type="submit" value="會計部確認" onClick={this.confirm} />
            </div> :
            <div className={styles.submit}>
              <span>工時已確認</span>
            </div>
          }
          {
            (weekReport && weekReport.isDone && me.role === 'admin') ?
            <div className={styles.submit}>
              <input type="submit" value="取消確認" onClick={this.revert} />
            </div> : null
          }
        </div>
      )
    }

    return (
      <div className={styles.reviewTable}>
        <div className={styles.reviewTitle}>加班審查：
          {reviewState}
        </div>
        <div className={styles.reviewRowHeader} >
          <div className={styles.projectName} >專案名稱</div>
          <div className={styles.overtime} >加班時數</div>
          <div className={styles.accept} >通過</div>
          <div className={styles.reject} >退回</div>
        </div>
        {weekReport.reviews.map(review =>
          <ReviewRow
            key={review.projectId}
            me={me}
            review={review}
            projects={projects}
            projectNames={projectNames}
            userNames={userNames}
            onWeekReportChange={onWeekReportChange}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/reviewTable.jsx